import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Standard circular back button used across the app's page headers.
 * Usage: <BackButton /> or <BackButton to="/somewhere" style={{ marginBottom:10 }} />
 */
export default function BackButton({ to, onClick, style, dark = false }) {
  const navigate = useNavigate();

  const handleClick = onClick || (() => (to ? navigate(to) : navigate(-1)));

  return (
    <button onClick={handleClick}
      style={{
        width:34, height:34, borderRadius:'50%',
        background: dark ? 'rgba(0,0,0,.25)' : 'rgba(255,255,255,.25)',
        border:'none', color:'white', fontSize:20, cursor:'pointer',
        display:'flex', alignItems:'center', justifyContent:'center',
        flexShrink:0,
        ...style,
      }}>
      ‹
    </button>
  );
}
